var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_8127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7934 13.6C16.9849 13.0884 17.082 12.5463 17.0801 12C17.0801 10.7871 16.5983 9.62383 15.7406 8.76616C14.8829 7.9085 13.7197 7.42667 12.5068 7.42667C11.9672 7.4273 11.4321 7.52438 10.9268 7.71333L12.0001 8.82C12.1633 8.7939 12.3282 8.78052 12.4934 8.78C13.351 8.77821 14.1745 9.11583 14.7841 9.71913C15.3936 10.3224 15.7397 11.1424 15.7468 12C15.7462 12.1652 15.7328 12.3302 15.7068 12.4933L16.7934 13.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8601 11.6867C20.6134 7.53332 16.6734 5.01999 12.3134 5.01999C11.1263 5.02278 9.94718 5.21405 8.82007 5.58666L9.8934 6.66666C10.684 6.46234 11.4969 6.35709 12.3134 6.35332C16.0667 6.35332 19.4801 8.44665 21.5134 11.9733C20.7675 13.2817 19.7787 14.4357 18.6001 15.3733L19.5467 16.32C20.9108 15.2195 22.0436 13.8601 22.8801 12.32L23.0534 12L22.8601 11.6867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24667 3.85332L6.22 6.82665C4.34062 8.03673 2.8046 9.7105 1.76 11.6867L1.58667 12L1.76 12.32C4.00667 16.4733 7.94667 18.9867 12.3067 18.9867C14.0084 18.9863 15.6881 18.6011 17.22 17.86L20.5533 21.1933L21.72 20.1933L4.38667 2.85999L3.24667 3.85332ZM9.74667 10.3533L14.18 14.7867C13.6791 15.0967 13.1024 15.2628 12.5133 15.2667C12.0853 15.2667 11.6615 15.182 11.2663 15.0176C10.871 14.8532 10.5122 14.6123 10.2105 14.3087C9.90875 14.0051 9.67002 13.6448 9.50804 13.2486C9.34606 12.8524 9.26403 12.428 9.26667 12C9.27418 11.4177 9.44012 10.8484 9.74667 10.3533ZM8.78 9.38665C8.15629 10.2663 7.86395 11.3382 7.95475 12.4126C8.04554 13.4871 8.51361 14.4948 9.27607 15.2572C10.0385 16.0197 11.0462 16.4878 12.1207 16.5786C13.1951 16.6694 14.2671 16.377 15.1467 15.7533L16.2133 16.82C14.9785 17.3478 13.6496 17.62 12.3067 17.62C8.55334 17.62 5.14 15.5267 3.10667 12C4.08247 10.2721 5.48782 8.82545 7.18667 7.79999L8.78 9.38665Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_8127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password_hide.9a39c07465bf4bb8dd111bfc218121c0.svg";
export { ForwardRef as ReactComponent };